import React from 'react';
import "./Replay.scss";
import { CgSmileMouthOpen } from "react-icons/cg";
import { GoPlus } from "react-icons/go";
import { FiSend } from "react-icons/fi";


export default function Replay() {
  return (
    <div className="d-flex align-items-center justify-content-center replay-wrapper">
      <div className="replay-box">
        <h3 className="mb-3 text-center">Replay</h3>

        <div className="msg">
          <span className="fw-bold">[Name]</span>
          <p className="m-0 p-0">[Name@email.com]</p>
          <p className="mb-0">
            Lorem ipsum dolor sit amet consectetur adipisicing <br />
            elit. Nihil, obcaecati laboriosam! Consectetur veniam dolor et.
          </p>
        </div>

        <div className="">
          <input type="text" className="type-replay form-control"  />
        </div>
<div className=' d-flex align-items-center  justify-content-between'>
  <div style={{
    color:"#8696a0",
    fontSize:"23px"
  }}   className=' d-flex align-items-center gap-3 '>
<CgSmileMouthOpen/>
          <GoPlus/>
  </div>
 

          <button className='btn-send d-flex align-items-center gap-2'>Send <FiSend/></button>
</div>
         
      </div>
    
    </div>
  );
}
